import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";
import { CreateUnavailabilityError } from "@planzone/dto";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  error: CreateUnavailabilityError;
  createUnavailability(
    request: Boundaries["createUnavailability"]["request"],
  ): void;
}

function useUnavailabilityCreation(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isUnavailabilityCreationRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isUnavailabilityCreationRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isUnavailabilityCreationRequestFailure,
    ),
    error: useSelector(selector.getUnavailabilityCreationError),
    createUnavailability: core.createUnavailability,
  };
}

export { useUnavailabilityCreation };
